const getDefaultState = () => {
  return {
    welcomeVideoOpen: false,
    welcomeVideoStarted: false,

    hasWatchedVideo: false,
    hasBookedSession: false,
    hasCompletedSession: false,
    hasSentInvite: false,

    onboardingComplete: false,

    onboardingLoaded: false,
  };
};

const state = getDefaultState();

// Synchronous
const mutations = {
  RESET_STATE(state) {
    Object.assign(state, getDefaultState());
  },

  SET_WELCOME_VIDEO(state, newValue) {
    state.welcomeVideoOpen = newValue;
  },

  SET_WELCOME_STARTED(state, newValue) {
    state.welcomeVideoStarted = newValue;
  },

  SET_HAS_BOOKED_SESSION(state, newValue) {
    state.hasBookedSession = newValue;
    if (state.hasBookedSession === true && state.hasWatchedVideo === true && state.hasCompletedSession === true) {
      state.onboardingComplete = true;
    }
  },

  SET_HAS_WATCHED_VIDEO(state, newValue) {
    state.hasWatchedVideo = newValue;
    if (state.hasBookedSession === true && state.hasWatchedVideo === true && state.hasCompletedSession === true) {
      state.onboardingComplete = true;
    }
  },

  SET_HAS_COMPLETED_SESSION(state, newValue) {
    state.hasCompletedSession = newValue;
    if (state.hasBookedSession === true && state.hasWatchedVideo === true && state.hasCompletedSession === true) {
      state.onboardingComplete = true;
    }
  },

  SET_ONBOARDING_STATES(state, values) {
    /* Check if user has watched intro video */
    if (values.hasWatchedVideo || values.hasWatchedVideo === false) {
      state.hasWatchedVideo = values.hasWatchedVideo;
    }

    // if (!state.hasWatchedVideo) {
    //   state.welcomeVideoOpen = true;
    // }

    /* Check if user has booked a session */
    if (values.hasBookedSession || values.hasBookedSession === false) {
      state.hasBookedSession = values.hasBookedSession;
    }

    /* Check if user has completed any sessions */
    if (values.sessionCount && values.sessionCount > 0) {
      state.hasCompletedSession = true;
    }

    /* Check if onboarding complete */
    if (state.hasBookedSession === true && state.hasWatchedVideo === true && state.hasCompletedSession === true) {
      state.onboardingComplete = true;
    }

    state.onboardingLoaded = true;
  },
};

// Asynchronous
const actions = {
  resetState({ commit }) {
    commit("RESET_STATE");
  },

  setWelcomeVideo({ commit }, newValue) {
    commit("SET_WELCOME_VIDEO", newValue);
  },

  setWelcomeStarted({ commit }, newValue) {
    commit("SET_WELCOME_STARTED", newValue);
  },

  setHasBookedSession({ commit }, newValue) {
    commit("SET_HAS_BOOKED_SESSION", newValue);
  },

  setHasWatchedVideo({ commit }, newValue) {
    console.log("test");
    commit("SET_HAS_WATCHED_VIDEO", newValue);
  },

  setHasCompletedSession({ commit }, newValue) {
    commit("SET_HAS_COMPLETED_SESSION", newValue);
  },

  setOnboardingStates({ commit }, values) {
    commit("SET_ONBOARDING_STATES", values);
  },
};

const onboarding = {
  namespaced: true,

  state,
  mutations,
  actions,
};

export default onboarding;
